import Axios from 'axios';

Axios.defaults.baseURL = 'https://api.nayrtech.com/api';
// Axios.defaults.baseURL = 'https://flight.marinersforex.com/api';

export const axiosInstance = Axios.create({});
